// Others
export const CRITICAL = "critical";
export const ATTACH = "attach";
export const DETACH = "detach";
export const REPLACE = "replace";
export const LOGOUT = "LOGOUT";
// Default state
export const DEFAULT_STATE = { isFetching: true, isError: false, response: {} };
export const DEFAULT_STATE_FF_EF = {
  isFetching: false,
  isError: false,
  response: {}
};
export const DEFAULT_STATE_FF_ET = {
  isFetching: false,
  isError: true,
  response: {}
};
// Filters
export const DASHBOAR_FILTER_DAY = "DAY";
export const DASHBOAR_FILTER_WEEK = "WEEK";
export const DASHBOAR_FILTER_MONTH = "MONTH";
export const DASHBOAR_FILTER_YEAR = "YEAR";

// File Upload Report
export const DEVICE_UPLOAD_REPORT = "DEVICE_UPLOAD_REPORT";

// API action common constants
export const PENDING = "PENDING";
export const FULFILLED = "FULFILLED";
export const REJECTED = "REJECTED";
//Settings
export const SETTING = "SETTING";
// Auth
export const LOGIN = "LOGIN";
export const GET_CSRF = "GET_CSRF";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
// General
export const DELETE = "DELETE";
export const STATUS_UPDATE = "STATUS_UPDATE";
// Others
export const GRID = "GRID";
export const IMAGE_UPLOAD = "IMAGE_UPLOAD";
export const FILE_UPLOAD = "FILE_UPLOAD";
// Customer
export const CUSTOMERS = "CUSTOMERS";
export const CUSTOMER_DELETE = "CUSTOMER_DELETE";
export const CUSTOMER_STATUS_UPDATE = "CUSTOMER_STATUS_UPDATE";
export const CUSTOMER = "CUSTOMER";
export const CUSTOMERSELECT = "CUSTOMERSELECT";
export const LOCATIONCATEGORY = "LOCATIONCATEGORY";
export const CATEGORY = "CATEGORY";
export const LAMPBRAND = "LAMPBRAND";
export const ALL_CUSTOMERS = "ALL_CUSTOMERS";
export const CUSTOMER_UTILITY_TYPE = "CUSTOMER_UTILITY_TYPE";
// User
export const USERS = "USERS";
export const USER_DELETE = "USER_DELETE";
export const USER_STATUS_UPDATE = "USER_STATUS_UPDATE";
export const USER = "USER";
export const USER_FIELD_ENGINEERS = "USER_FIELD_ENGINEERS";
export const ALL_USERS = "ALL_USERS";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const USER_PROFILE = "USER_PROFILE";
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
// MASTER DATA
export const CITY = "CITY";
export const CITY_FILTER = "CITY_FILTER";
export const COUNTRY = "COUNTRY";
export const STATE = "STATE";
export const META_PRODUCT_TYPES = "META_PRODUCT_TYPES";
export const ALL_UTILITIES = "ALL_UTILITIES";
export const PINCODE = "PINCODE";
export const ROLE_TYPE = "ROLE_TYPE";
export const LOCATION_TYPE = "LOCATION_TYPE";
export const LOCATION_TYPE_PROFILE = "LOCATION_TYPE_PROFILE";
export const CITY_PROFILE = "CITY_PROFILE";
export const PINCODE_PROFILE = "PINCODE_PROFILE";
export const COUNTRY_PROFILE = "COUNTRY_PROFILE";
//ADDRESS MASTER DATA
export const ADDRESS_MASTER_DATA_FROM = "ADDRESS_MASTER_DATA";
export const ADDRESS_MASTER_DATA_LIST = "ADDRESS_MASTER_DATA_LIST";
export const ADDRESS_MASTER_DATA_DELETE = "ADDRESS_MASTER_DATA_DELETE";
export const ADDRESS_MASTER_DATA_STATUS_UPDATE =
  "ADDRESS_MASTER_DATA_STATUS_UPDATE";
//STATE
export const STATE_LIST = "STATE_LIST";
export const STATE_FORM = "STATE_FORM";
export const STATE_DELETE = "STATE_DELETE";
export const STATE_STATUS_UPDATE = "STATE_STATUS_UPDATE";
export const ALL_STATES = "ALL_STATES";
export const STATE_PROFILE = "STATE_PROFILE";
//CITY
export const CITY_LIST = "CITY_LIST";
export const CITY_FORM = "CITY_FORM";
export const CITY_DELETE = "CITY_DELETE";
export const CITY_STATUS_UPDATE = "CITY_STATUS_UPDATE";
export const ALL_CITIES = "ALL_CITIES";
//PINCODE
export const PINCODE_LIST = "PINCODE_LIST";
export const PINCODE_FORM = "PINCODE_FORM";
export const PINCODE_DELETE = "PINCODE_DELETE";
export const PINCODE_STATUS_UPDATE = "PINCODE_STATUS_UPDATE";
export const ALL_PINCODES = "ALL_PINCODES";
// Site
export const SITE = "SITE";
export const SITES = "SITES";
export const SITE_DELETE = "SITE_DELETE";
export const SITE_STATUS_UPDATE = "SITE_STATUS_UPDATE";
export const SITESELECT = "SITESELECT";
export const SITESELECT_PROFILE = "SITESELECT_PROFILE";
// Device
export const DEVICE = "DEVICE";
export const DEVICE_ADD = "DEVICE_ADD";
export const DEVICE_UPDATE = "DEVICE_UPDATE";
export const DEVICE_SELECT = "DEVICE_SELECT";
export const DEVICES = "DEVICES";
export const DEVICE_DELETE = "DEVICE_DELETE";
export const DEVICE_STATUS_UPDATE = "DEVICE_STATUS_UPDATE";
export const DEVICE_STATUS_LIST = "DEVICE_STATUS_LIST";
export const DEVICES_INVENTORY = "DEVICES_INVENTORY";
export const DEVICE_ASSIGN = "DEVICE_ASSIGN";
export const DEVICE_STATUS_HISTORY = "DEVICE_STATUS_HISTORY";
export const ATTACH_DEVICE_TO_PROP = "ATTACH_DEVICE_TO_PROP";
export const DETACH_DEVICE_FROM_PROP = "DETACH_DEVICE_FROM_PROP";
export const DEVICE_OFFLINE_CONFIG = "DEVICE_OFFLINE_CONFIG";
export const DEVICE_OFFLINE_CONFIG_ADD = "DEVICE_OFFLINE_CONFIG_ADD";
export const DEVICE_DOWNLINK = "DEVICE_DOWNLINK";

// Role
export const ROLES = "ROLES";
export const ROLE = "ROLE";
export const PERMISSIONS = "PERMISSIONS";
export const PERMISSION = "PERMISSION";
// Email
export const EMAILS = "EMAILS";
export const EMAIL = "EMAIL";
export const EMAIL_DELETE = "EMAIL_DELETE";
export const EMAIL_STATUS_UPDATE = "EMAIL_STATUS_UPDATE";
// Product Types
export const PRODUCT_TYPES = "PRODUCT_TYPES";
export const PRODUCT_TYPE = "PRODUCT_TYPE";
export const PRODUCT_TYPE_DELETE = "PRODUCT_TYPE_DELETE";
export const PRODUCT_TYPE_STATUS_UPDATE = "PRODUCT_TYPE_STATUS_UPDATE";

// Product
export const PRODUCTS = "PRODUCTS";
export const PRODUCT = "PRODUCT";
export const PRODUCT_DELETE = "PRODUCT_DELETE";
export const PRODUCT_STATUS_UPDATE = "PRODUCT_STATUS_UPDATE";
export const PRODUCT_SELECT = "PRODUCT_SELECT";

// POLE
export const POLES = "POLES";
export const POLE = "POLE";
export const POLE_DELETE = "POLE_DELETE";
export const POLE_STATUS_UPDATE = "POLE_STATUS_UPDATE";
export const POLE_SELECT = "POLE_SELECT";

// POLE
export const LAMPS = "LAMPS";
export const LAMP = "LAMP";
export const LAMP_DELETE = "LAMP_DELETE";
export const LAMP_STATUS_UPDATE = "LAMP_STATUS_UPDATE";
export const LAMP_SELECT = "LAMP_SELECT";
// FEEDERS
export const FEEDERS = "FEEDERS";
export const FEEDER = "FEEDER";
export const FEEDER_DELETE = "FEEDER_DELETE";
export const FEEDER_STATUS_UPDATE = "FEEDER_STATUS_UPDATE";
export const FEEDER_SELECT = "FEEDER_SELECT";
export const FEEDER_ASSIGN = "FEEDER_ASSIGN";

// LED_LOAD
export const LED_LOADS = "LED_LOADS";
export const LED_LOAD = "LED_LOAD";
export const LED_LOAD_DELETE = "LED_LOAD_DELETE";
export const LED_LOAD_STATUS_UPDATE = "LED_LOAD_STATUS_UPDATE";
export const LED_LOAD_SELECT = "LED_LOAD_SELECT";

// PROJECT
export const PROJECTS = "PROJECTS";
export const PROJECT = "PROJECT";
export const PROJECT_DELETE = "PROJECT_DELETE";
export const PROJECT_STATUS_UPDATE = "PROJECT_STATUS_UPDATE";
export const PROJECT_SELECT = "PROJECT_SELECT";

// SMS
export const SMSS = "SMSS";
export const SMS = "SMS";
export const SMS_DELETE = "SMS_DELETE";
export const SMS_STATUS_UPDATE = "SMS_STATUS_UPDATE";
// CONSUMER
export const CONSUMER_LIST = "CONSUMER_LIST";
// REPORT
//ILM
export const REPORT_DEVICE_INSTALLATION = "REPORT_DEVICE_INSTALLATION";
export const REPORT_FAILURE_DEVICE_INSTALLATION =
  "REPORT_FAILURE_DEVICE_INSTALLATION";
export const REPORT_SUCCESS_DEVICE_INSTALLATION =
  "REPORT_SUCCESS_DEVICE_INSTALLATION";
export const ONESTEP_ONBOARD_DEVICE = "ONESTEP_ONBOARD_DEVICE";
export const ONESTEP_ONBOARD_DEVICE_SUBMIT = "ONESTEP_ONBOARD_DEVICE_SUBMIT";
//GLM
export const REPORT_FEEDER_INSTALLATION = "REPORT_FEEDER_INSTALLATION";
export const REPORT_FAILURE_FEEDER_INSTALLATION =
  "REPORT_FAILURE_FEEDER_INSTALLATION";
export const REPORT_SUCCESS_FEEDER_INSTALLATION =
  "REPORT_SUCCESS_FEEDER_INSTALLATION";
// LOG
export const LOG = "LOG";
export const LOGS = "LOGS";
export const LOG_DELETE = "LOG_DELETE";

// PROPERTY
export const PROPERTY = "PROPERTY";
export const PROPERTY_DELETE = "PROPERTY_DELETE";
export const PROPERTY_STATUS_UPDATE = "PROPERTY_STATUS_UPDATE";
export const PROPERTY_SELECT = "PROPERTY_SELECT";
export const PROPERTY_ADD = "PROPERTY_ADD";
export const PROPERTY_UPDATE = "PROPERTY_UPDATE";

export const HIERARCHY = "HIERARCHY";

export const PROPERTY_FIELDS = "PROPERTY_FIELDS";

export const DEVICEHISTORY = "DEVICEHISTORY";
export const DEVICEHISTORY_UPDATE = "DEVICEHISTORY_UPDATE";
export const DEVICEHISTORY_SELECT = "DEVICEHISTORY_SELECT";


//Firmware
export const FIRMWARE = "FIRMWARE";
export const FIRMWARE_ADD = "FIRMWARE_ADD";
export const FIRMWARE_UPDATE = "FIRMWARE_UPDATE";
export const FIRMWARES = "FIRMWARES";
export const FIRMWARE_DELETE = "FIRMWARE_DELETE";
export const BUILD_NUMBER_TYPES = "BUILD_NUMBER_TYPES";
export const REPORT_FIRMWARE_UPDATION = "REPORT_FIRMWARE_UPDATION"